/**
 * PICK YOUR WAIFU — homepage section JS.
 * IIFE — no global pollution. Pulls all data from DOM data-attrs
 * rendered by the Liquid section. No JSON parsing.
 *
 * Behavior:
 *   - Click a badge → spotlight body + name + archetype + tagline + CTA href update
 *   - Idle CRT scan sweep every 3.5s
 *   - Mobile: roster controls (prev/next) + scroll-snap + "Touch Me!" hint after 3s idle
 */
(function () {
  'use strict';

  function init(root) {
    if (!root) return;
    if (root.dataset.lfPywInitialized === '1') return;
    root.dataset.lfPywInitialized = '1';

    var spotlightFrame  = root.querySelector('.spotlight-frame');
    var spotlightBody   = root.querySelector('.spotlight-body');
    var waifuName       = root.querySelector('.waifu-name');
    var waifuArchetype  = root.querySelector('.waifu-archetype');
    var waifuTagline    = root.querySelector('.waifu-tagline');
    var waifuCta        = root.querySelector('.waifu-cta');
    var grid            = root.querySelector('.waifu-grid');
    var rosterPrev      = root.querySelector('.roster-arrow.prev');
    var rosterNext      = root.querySelector('.roster-arrow.next');
    var rosterCounter   = root.querySelector('.roster-counter');
    var touchMeHint     = root.querySelector('.touch-me-hint');

    if (!spotlightFrame || !grid) return;

    // ── Spotlight + badge selection ────────────────────────────────────
    function selectWaifu(badge) {
      var data = badge.dataset;
      if (!data.bodyImg) return;

      // Active state on badges
      var badges = grid.querySelectorAll('.waifu-badge');
      badges.forEach(function (b) { b.classList.remove('active'); });
      badge.classList.add('active');

      // CRT flash + sweep on spotlight
      spotlightFrame.classList.remove('flashing', 'scanning');
      void spotlightFrame.offsetWidth;
      spotlightFrame.classList.add('flashing');
      setTimeout(function () { spotlightFrame.classList.remove('flashing'); }, 850);

      // Sweep on newly selected badge
      badge.classList.remove('scanning');
      void badge.offsetWidth;
      badge.classList.add('scanning');
      setTimeout(function () { badge.classList.remove('scanning'); }, 850);

      // Update spotlight content after a short delay (after flash starts)
      setTimeout(function () {
        if (spotlightBody) {
          spotlightBody.style.opacity = '0';
          setTimeout(function () {
            spotlightBody.src = data.bodyImg;
            spotlightBody.alt = data.name || 'Selected waifu';
            spotlightBody.style.opacity = '1';
          }, 120);
        }
        if (waifuName)      waifuName.textContent      = data.name || '';
        if (waifuArchetype) waifuArchetype.textContent = '— ' + (data.archetype || '') + ' —';
        if (waifuTagline)   waifuTagline.textContent   = data.tagline || '';
        if (waifuCta && data.handle) waifuCta.setAttribute('href', '/collections/' + data.handle);
      }, 80);

      resetIdleLoop();
      resetTouchMe();
    }

    // ── Wire click handlers on all (non-locked) badges ─────────────────
    var allBadges = grid.querySelectorAll('.waifu-badge:not(.locked)');
    allBadges.forEach(function (b) {
      b.addEventListener('click', function () { selectWaifu(b); });
    });

    // ── Idle CRT scan loop ─────────────────────────────────────────────
    var IDLE_MS = 3500;
    var idleInterval;

    function triggerIdleScan() {
      if (!spotlightFrame) return;
      spotlightFrame.classList.remove('scanning', 'flashing');
      void spotlightFrame.offsetWidth;
      spotlightFrame.classList.add('scanning');
      setTimeout(function () { spotlightFrame.classList.remove('scanning'); }, 850);

      var active = grid.querySelector('.waifu-badge.active');
      if (active) {
        active.classList.remove('scanning');
        void active.offsetWidth;
        active.classList.add('scanning');
        setTimeout(function () { active.classList.remove('scanning'); }, 850);
      }
    }

    function resetIdleLoop() {
      if (idleInterval) clearInterval(idleInterval);
      idleInterval = setInterval(triggerIdleScan, IDLE_MS);
    }

    // Initial flash + start idle loop
    setTimeout(function () {
      spotlightFrame.classList.add('flashing');
      setTimeout(function () { spotlightFrame.classList.remove('flashing'); }, 850);
      var active = grid.querySelector('.waifu-badge.active');
      if (active) {
        setTimeout(function () {
          active.classList.add('scanning');
          setTimeout(function () { active.classList.remove('scanning'); }, 850);
        }, 100);
      }
      resetIdleLoop();
    }, 700);

    // ── Mobile roster scroller ─────────────────────────────────────────
    var scrollIndex = 0;

    function getAllBadges() {
      return grid.querySelectorAll('.waifu-badge');
    }

    function updateCounter() {
      if (!rosterCounter) return;
      var total = getAllBadges().length;
      rosterCounter.textContent =
        String(scrollIndex + 1).padStart(2, '0') + '/' + String(total).padStart(2, '0');
      if (rosterPrev) rosterPrev.disabled = scrollIndex <= 0;
      if (rosterNext) rosterNext.disabled = scrollIndex >= total - 1;
    }

    function scrollToBadgeIndex(idx) {
      var badges = getAllBadges();
      if (idx < 0 || idx >= badges.length) return;
      scrollIndex = idx;
      badges[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      updateCounter();
    }

    // ── "Touch Me!" hint (mobile, inactivity nudge) ───────────────────
    var touchMeShowTimer, touchMeHideTimer;

    function isMobileViewport() {
      return window.matchMedia('(max-width: 900px)').matches;
    }

    function hasPeekingBadge() {
      var badges = getAllBadges();
      return scrollIndex < badges.length - 1;
    }

    function showTouchMe() {
      if (!isMobileViewport() || !touchMeHint) return;
      if (!hasPeekingBadge()) {
        scheduleNextTouchMe(6000);
        return;
      }
      touchMeHint.classList.add('visible');
      clearTimeout(touchMeHideTimer);
      touchMeHideTimer = setTimeout(function () {
        touchMeHint.classList.remove('visible');
        scheduleNextTouchMe(6000);
      }, 3000);
    }

    function scheduleNextTouchMe(delay) {
      clearTimeout(touchMeShowTimer);
      touchMeShowTimer = setTimeout(showTouchMe, delay);
    }

    function resetTouchMe() {
      clearTimeout(touchMeShowTimer);
      clearTimeout(touchMeHideTimer);
      if (touchMeHint) touchMeHint.classList.remove('visible');
      if (isMobileViewport()) scheduleNextTouchMe(3000);
    }

    if (rosterPrev && rosterNext) {
      rosterPrev.addEventListener('click', function () {
        scrollToBadgeIndex(scrollIndex - 1);
        resetTouchMe();
      });
      rosterNext.addEventListener('click', function () {
        scrollToBadgeIndex(scrollIndex + 1);
        resetTouchMe();
      });
    }

    var scrollDebounce;
    grid.addEventListener('scroll', function () {
      resetTouchMe();
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        var badges = getAllBadges();
        if (badges.length === 0) return;
        var badgeWidth = badges[0].offsetWidth + 12;
        var newIdx = Math.round(grid.scrollLeft / badgeWidth);
        if (newIdx !== scrollIndex && newIdx >= 0 && newIdx < badges.length) {
          scrollIndex = newIdx;
          updateCounter();
        }
      }, 80);
    });

    updateCounter();
    if (isMobileViewport()) scheduleNextTouchMe(3000);

    window.addEventListener('resize', function () {
      if (!isMobileViewport()) {
        clearTimeout(touchMeShowTimer);
        clearTimeout(touchMeHideTimer);
        if (touchMeHint) touchMeHint.classList.remove('visible');
      } else {
        resetTouchMe();
      }
    });
  }

  // Init each section on the page (supports multiple instances)
  function initAll() {
    document.querySelectorAll('.waifu-select').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section reload (theme editor live preview)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      var root = e.target.querySelector('.waifu-select');
      if (root) init(root);
    }
  });
})();
